/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export const DATE_FORMATS = {
  printed: 'MM/DD/YYYY',
  printedWithTime: 'MM/DD/YYYY H:mm A',
  printedWithTime12H: 'MM/DD/YYYY hh:mm A',
}
